module.exports = __webpack_public_path__ + "static/media/it-IT.713759c0.md";